<div
  class="ui lable loggregation loggregation-occurrences-style"
  (click)="onClick()"
>
  {{ value }}
</div>
